import { useTranslation } from 'react-i18next';

import { Badge } from '../../components/Badge';
import { useArticleSuggestions } from './queries';
import { toneForVisibility } from './presentation';

/**
 * Loesungsvorschlaege waehrend der Erfassung -- F4-13, K-107.
 *
 * **Waehrend, nicht danach.** Der Katalog verlangt es ausdruecklich: Ein
 * Vorschlag, der erst nach dem Absenden kommt, hat den Vorgang schon
 * ausgeloest, den er verhindern sollte.
 *
 * Die Liste bleibt still, wenn sie nichts hat: keine Ueberschrift, kein
 * "keine Treffer". Ein Hinweis auf das Ausbleiben von Vorschlaegen waere
 * Laerm in einer Maske, die in wenigen Sekunden ausgefuellt werden soll.
 */
export function ArticleSuggestions({
  text,
  onOpen,
}: {
  text: string;
  onOpen?: (articleId: string) => void;
}) {
  const { t } = useTranslation();
  const suggestions = useArticleSuggestions(text);

  if (!suggestions.data || suggestions.data.length === 0) {
    return null;
  }

  return (
    <section className="card" aria-label={t('knowledge.suggestions')}>
      <h2>{t('knowledge.suggestions')}</h2>
      <p className="table__muted">{t('knowledge.suggestionsHint')}</p>

      <ul className="stack">
        {suggestions.data.map((article) => (
          <li key={article.id}>
            {/* Anklickbar nur dort, wo es ein Ziel gibt. Im Anlagedialog
                gibt es keines: Ein Sprung in die Wissensdatenbank verwuerfe
                die halb ausgefuellte Maske. */}
            {onOpen ? (
              <button
                type="button"
                className="table__subject"
                onClick={() => {
                  onOpen(article.id);
                }}
              >
                {article.title}
              </button>
            ) : (
              <span className="table__subject">{article.title}</span>
            )}{' '}
            <Badge tone={toneForVisibility(article.visibility)}>
              {t(`kbVisibility.${article.visibility}`)}
            </Badge>
            <div className="table__muted">{article.summary}</div>
          </li>
        ))}
      </ul>
    </section>
  );
}
